<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
    class: {
      type: String,
      default: '',
    },
    previewSize: {
      type: Number,
      default: 400,
    },
    safeSize: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      showPreviewPopup: false,
      cursorLeftPosition: 0,
      cursorTopPosition: 0,
    };
  },
  computed: {
    imageClass() {
      return this.class;
    },
    cursorPosition() {
      return {
        left: `${this.cursorLeftPosition}px`,
        top: `${this.cursorTopPosition}px`,
      };
    },
  },
  methods: {
    showPreview(event) {
      this.cursorLeftPosition = event.clientX + this.safeSize; // Offset to avoid cursor overlap
      this.cursorTopPosition = event.clientY + this.safeSize; // Offset to avoid cursor overlap
      if (this.cursorTopPosition + this.previewSize > window.innerHeight) {
        this.cursorTopPosition -= this.previewSize;
        this.cursorTopPosition -= this.safeSize * 2; // Additional offset to avoid overlap
      }
      if (this.cursorLeftPosition + this.previewSize > window.innerWidth) {
        this.cursorLeftPosition -= this.previewSize;
        this.cursorLeftPosition -= this.safeSize * 2; // Additional offset to avoid overlap
      }
      this.showPreviewPopup = true;
    },
    hidePreview() {
      this.showPreviewPopup = false;
    },
  },
};
</script>

<template>
  <img
    :src="src"
    :alt="alt"
    :class="imageClass"
    @mouseenter="showPreview"
    @mouseleave="hidePreview"
  />
  <div
    v-if="showPreviewPopup"
    class="fixed z-50 bg-white shadow-lg rounded-2xl p-2"
    :style="cursorPosition"
  >
    <img
      :src="src"
      :alt="alt"
      :class="`max-w-[${previewSize}px] max-h-[${previewSize}px] object-cover rounded-2xl`"
    />
  </div>
</template>
